import { render, staticRenderFns } from "./KuickPayBPS.vue?vue&type=template&id=fe844608&scoped=true&"
import script from "./KuickPayBPS.vue?vue&type=script&lang=js&"
export * from "./KuickPayBPS.vue?vue&type=script&lang=js&"
import style0 from "./KuickPayBPS.vue?vue&type=style&index=0&id=fe844608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe844608",
  null
  
)

export default component.exports